import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { utils } from '../../utils';
import type { CreateCustomFieldData, CustomFieldModel } from '../../types/customField';
import type { EndpointResponse } from '../../types/endpoints';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  model: CustomFieldModel;
  data: CreateCustomFieldData[];
};

type Response = unknown;

const validate = (model: CustomFieldModel, data: CreateCustomFieldData[]) => {
  if (!model) {
    throw new Error('`model` is required');
  }
  if (!Array.isArray(data) || data.length < 1) {
    throw new Error('`data` must be a non-empty array');
  }
  for (const item of data) {
    if (!item?.name) {
      throw new Error('`data[].name` is required');
    }
    if (!item?.meta_field_type) {
      throw new Error('`data[].meta_field_type` is required');
    }
  }
};

export const createCustomFieldsBulk = async (
  scope: RequestScope,
  { model, data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(model, data);

    // API expects the array payload directly (no `{ data: ... }` wrapper)
    const result = await scopedApi(scope).post<EndpointResponse<Response>>(`${model}/fields`, data, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
